module.exports = __webpack_public_path__ + "img/militaryscience-h-474x356.8656e026.jpg";